import React from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/delgro_logo.svg";

const DelgroLogoSVG = () => {
  return (
    <Link to="/">
      <div className="w-fit flex-shrink-0 cursor-pointer">
        <img src={logo} alt="logo" className="h-12 w-auto" />
      </div>
    </Link>
  );
};

export default DelgroLogoSVG;
